const columns = [
  {
    title: '下载入口',
    links: [
      { label: '安卓版', href: '#versions' },
      { label: '最新版', href: '#versions' },
      { label: '安装包', href: '#versions' },
    ],
  },
  {
    title: '使用相关',
    links: [
      { label: '使用体验', href: '#experience' },
      { label: '安装指引', href: '#install' },
      { label: '常见问题', href: '#faq' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-50 border-t border-primary-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-compasses-2-fill text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">91浏览器</span>
            </div>
            <p className="mt-5 text-sm text-foreground-600 leading-relaxed max-w-sm">
              一页看懂手机版怎么下载、怎么安装、怎么升级。把入口理清楚，剩下的交给一步步的操作。
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <h4 className="font-heading font-semibold text-sm text-foreground-950">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-primary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 91浏览器下载指引页 · 本页为静态展示内容
          </p>
          <p className="text-xs text-foreground-500">
            安装包以实际发布版本为准，请按页面指引完成安装
          </p>
        </div>
      </div>
    </footer>
  );
}